export const simulateGoldInvestment = (params) => {
  const {
    propertyValue,            // One-time initial investment
    goldStartPrice,           // Gold price at year 0
    goldGrowthRate,           // Annual % growth
    termYears,                // Investment term in years
    monthlyInvestmentAmount,  // NEW: Recurring monthly investment
  } = params;

  const yearlyData = [];
  let currentGoldPrice = goldStartPrice;
  let goldQuantity = propertyValue / goldStartPrice; // Initial investment in gold

  const totalMonths = termYears * 12;

  // Simulate month-by-month
  for (let month = 1; month <= totalMonths; month++) {
    // Update monthly gold price using compound interest formula
    const monthlyGrowthRate = goldGrowthRate / 100 / 12;
    currentGoldPrice *= (1 + monthlyGrowthRate);

    // Buy gold every month
    const monthlyGoldPurchased = monthlyInvestmentAmount / currentGoldPrice;
    goldQuantity += monthlyGoldPurchased;

    // At each 12th month (yearly summary), record data
    if (month % 12 === 0) {
      const year = month / 12;
      const goldValue = goldQuantity * currentGoldPrice;

      yearlyData.push({
        year,
        goldPrice: Math.round(currentGoldPrice),
        goldValue: Math.round(goldValue),
        totalGoldAccumulated: goldQuantity.toFixed(4),
      });
    }
  }

  const finalYear = yearlyData[yearlyData.length - 1];
  const totalInvestment = propertyValue + (monthlyInvestmentAmount * totalMonths);
  const finalValue = finalYear.goldValue;

  const investorResult = {
    model: 'Gold Investment',
    finalValue: Math.round(finalValue),
    assetAppreciation: Math.round(finalValue - totalInvestment),
    totalROI: (((finalValue - totalInvestment) / totalInvestment) * 100).toFixed(1),
    annualizedROI: ((Math.pow(finalValue / totalInvestment, 1 / termYears) - 1) * 100).toFixed(1),
    originalInvestmentValue: Math.round(propertyValue),
    recurringMonthly: monthlyInvestmentAmount,
    totalInvestment: Math.round(totalInvestment),
    totalGoldAccumulated: goldQuantity.toFixed(4),
    goldPriceAtEnd: Math.round(currentGoldPrice),
    netCashflow: 0,
    cashOnCashReturn: 0,
    irrEstimate: ((Math.pow(finalValue / totalInvestment, 1 / termYears) - 1) * 100).toFixed(1),
    exitValue: Math.round(finalValue),
    finalNetProfit: Math.round(finalValue - totalInvestment),
    termYears,
  };

  console.log('Gold',yearlyData);
  return {
    investorResult,
    borrowerResult: null,
    yearlyData,
  };
};
